import styled, { css } from 'styled-components';
import { mediaQueries } from '../../providers/MediaQueryProvider';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  background: var(--bg-primary);
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-brand);
  box-shadow: 0 1px 2px 0 #00000026;
  padding: var(--space-200);
  gap: var(--space-300);

  ${({ bare }) => bare &&
    css `
      border: none;
      box-shadow: none;
      padding: 0;
    `}
`;
export const MonthsContainer = styled.div `
  display: flex;
  gap: var(--space-600);
  flex: 1;

  ${mediaQueries.tablet} {
    align-items: flex-start;
  }
`;
export const MonthContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-100);
  justify-content: center;
  flex: 1;
`;
export const MonthHeader = styled.div `
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
`;
export const MonthHeaderButton = styled.button `
  cursor: pointer;
  color: var(--text-primary);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
  padding: var(--space-150) var(--space-250);
  border-radius: var(--radius-brand);

  &:hover {
    background: var(--bg-transparent-strong);
  }
`;
export const MonthHeaderPrevArrowContainer = styled.div `
  position: absolute;
  left: 0;
`;
export const MonthHeaderNextArrowContainer = styled.div `
  position: absolute;
  right: 0;
`;
export const MonthDaysContainer = styled.div `
  display: grid;
  grid-template-columns: repeat(7, 40px);
  justify-content: center;
`;
export const YearsDropdownContainer = styled.div `
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  justify-content: center;
  gap: var(--space-400);
  background: var(--bg-primary);
  border: 1px solid var(--border-transparent);
  box-shadow: 0 1px 2px 0 #00000026;
  border-radius: var(--radius-brand);
  padding: var(--space-200);
`;
export const Year = styled.button `
  width: 64px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-primary);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
  border-radius: var(--radius-brand);

  &:hover {
    background: var(--bg-transparent-strong);
  }

  ${({ $active }) => $active &&
    css `
      background: var(--bg-transparent-strong);
    `}
`;
export const WeekDay = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: var(--text-secondary);
  font-weight: 400;
  font-size: var(--font-size-200);
  line-height: var(--font-line-height-200);
  letter-spacing: var(--font-letter-spacing-loose);
`;
export const Day = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: var(--text-primary);
  border-radius: var(--radius-brand);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);

  &:hover {
    background: var(--bg-transparent-strong);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;

    &:hover {
      background: transparent;
    }
  }

  ${({ $hidden }) => $hidden &&
    css `
      cursor: default;
      opacity: 0;

      &:disabled {
        cursor: default;
        opacity: 0;
      }
    `}

  ${({ $selected }) => $selected &&
    css `
      background: var(--bg-primary-invert);
      color: var(--text-primary-invert);

      &:hover {
        background: var(--bg-primary-invert);
      }
    `}

  ${({ $inRange }) => $inRange &&
    css `
      background: var(--bg-transparent);
      border-radius: 0;

      &:hover {
        background: var(--bg-transparent);
      }
    `}
`;
export const TimeContainer = styled.div `
  display: flex;
  gap: var(--space-200);
`;
export const TimeInputContainer = styled.div `
  position: relative;
  flex: 1;
`;
export const TimeInputMask = styled.div `
  position: absolute;
  top: 14px;
  left: 42px;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  pointer-events: none;
  color: var(--text-secondary);
`;
export const TimeInputMaskLetter = styled.span `
  white-space: pre;

  ${({ $hidden }) => $hidden &&
    css `
      opacity: 0;
    `}
`;
